import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main
  },
  {
    path: '/leads',
    name: 'Leads',
    component: Main
  },
  {
    path: '/leads/:ids',
    name: "Lead",
    component: Main,
  },
]

const router = new VueRouter({
  routes
})

export default router
